import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { useTable } from 'react-table';
import CardTitle from '../../../../../components/CardTitle';
import Currency from '../../../../../components/Currency';

import { IState } from '../../../../../store';
import { IProfit } from '../../../../../store/modules/profit/types';

import * as Styled from './styles';

interface SectorsRankProps {
  profits: IProfit[];
}

const SectorsRank: React.FC<SectorsRankProps> = ({
  profits,
}) => {
  const data = useMemo(() => {
    const actives = [] as any;

    for (const profit of profits) {
      const active = actives.find((active: any) => active.name === profit.sector || (!profit.sector && active.name === 'Outros'));

      if (active) {
        active.total += profit.profit;
      } else {
        actives.push({
          name: profit.sector || 'Outros',
          wallet_name: profit.wallet_name,
          total: profit.profit,
        });
      }
    }

    return actives.sort((a: any, b: any) => b.total - a.total);
  }, [profits]);

  const columns: any = useMemo(() => {
    return (
      [
        {
          Header: 'Setor',
          accessor: 'name',
        },
        {
          Header: 'Receita',
          accessor: 'total',
          collapse: true,
        },
      ]
    )
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
  } = useTable(
    {
      columns,
      data,
    }
  )

  return (
    <Styled.Container>
      <Styled.TableWrap className="tableWrap">
        <Styled.Table {...getTableProps()}>
          <Styled.Head>
            {headerGroups.map(headerGroup => (
              <Styled.HeadRow {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column: any) => (
                  <Styled.HeadData
                    {...column.getHeaderProps({
                      className: column.collapse ? 'collapse' : '',
                    })}
                  >
                    {column.render('Header')}
                  </Styled.HeadData>
                ))}
              </Styled.HeadRow>
            ))}
          </Styled.Head>
          <Styled.TableBody {...getTableBodyProps()}>
            {rows.map((row: any, i: number) => {
              prepareRow(row)
              return (
                <Styled.HeadRow {...row.getRowProps()}>
                  {row.cells.map((cell: any) => {
                    return (
                      <Styled.Content
                        {...cell.getCellProps({
                          className: cell.column.collapse ? 'collapse' : '',
                        })}
                      >
                        {cell.column.Header === 'Setor' && (
                          <span><strong>{cell.value}</strong></span>
                        )}

                        {cell.column.Header === 'Receita' && (
                          <Currency
                            value={cell.value}
                          />
                        )}
                      </Styled.Content>
                    )
                  })}
                </Styled.HeadRow>
              )
            })}
          </Styled.TableBody>
        </Styled.Table>
      </Styled.TableWrap>
    </Styled.Container>
  )
}

const mapStateToProps = (state: IState) => ({
  profits: state.profit.profits
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(SectorsRank)
